"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usageTypeData = exports.commercialUsageTypes = exports.UsageType = exports.UsageTypeCategory = exports.AudioMadeMove = exports.CableMarket = exports.GlobalMarket = exports.UsesType = exports.UsageLanguage = exports.MarketSpecification = exports.UsagePlatform = exports.MediaCategory = exports.UsageCycleUnit = exports.UsageCycleNumber = exports.UsageCities = exports.UsageUnitType = void 0;
const commercial_types_1 = require("./commercial-types");
/**
 * Usage Unit Type
 */
var UsageUnitType;
(function (UsageUnitType) {
    UsageUnitType["Uses"] = "Uses";
    UsageUnitType["Cities"] = "Cities";
})(UsageUnitType || (exports.UsageUnitType = UsageUnitType = {}));
var UsageCities;
(function (UsageCities) {
    UsageCities["NY"] = "New York";
    UsageCities["LA"] = "Los Angeles";
    UsageCities["Chicago"] = "Chicago";
    UsageCities["Minor"] = "Minor Markets";
})(UsageCities || (exports.UsageCities = UsageCities = {}));
var UsageCycleNumber;
(function (UsageCycleNumber) {
    UsageCycleNumber[UsageCycleNumber["one"] = 1] = "one";
    UsageCycleNumber[UsageCycleNumber["four"] = 4] = "four";
    UsageCycleNumber[UsageCycleNumber["six"] = 6] = "six";
    UsageCycleNumber[UsageCycleNumber["eight"] = 8] = "eight";
    UsageCycleNumber[UsageCycleNumber["thirteen"] = 13] = "thirteen";
    UsageCycleNumber[UsageCycleNumber["twentySix"] = 26] = "twentySix";
    UsageCycleNumber[UsageCycleNumber["thirty"] = 30] = "thirty";
    UsageCycleNumber[UsageCycleNumber["thirtyOne"] = 31] = "thirtyOne";
    UsageCycleNumber[UsageCycleNumber["fiftyTwo"] = 52] = "fiftyTwo";
    UsageCycleNumber[UsageCycleNumber["oneHundredFour"] = 104] = "oneHundredFour";
})(UsageCycleNumber || (exports.UsageCycleNumber = UsageCycleNumber = {}));
var UsageCycleUnit;
(function (UsageCycleUnit) {
    UsageCycleUnit["Day"] = "Day";
    UsageCycleUnit["Week"] = "Week";
    UsageCycleUnit["Month"] = "Month";
    UsageCycleUnit["Year"] = "Year";
})(UsageCycleUnit || (exports.UsageCycleUnit = UsageCycleUnit = {}));
// Create base types for media category and platform
var MediaCategory;
(function (MediaCategory) {
    MediaCategory["TV"] = "TV";
    MediaCategory["Digital"] = "Digital";
    MediaCategory["Social"] = "Social Media";
    MediaCategory["OOH"] = "Out-of-home";
    MediaCategory["Radio"] = "Radio";
})(MediaCategory || (exports.MediaCategory = MediaCategory = {}));
var UsagePlatform;
(function (UsagePlatform) {
    UsagePlatform["Linear"] = "Linear";
    UsagePlatform["Digital"] = "Digital";
    UsagePlatform["SocialWaiver"] = "Social Media Waiver";
    UsagePlatform["TheatricalIndustrial"] = "Theatrical/Industrial";
    UsagePlatform["Foreign"] = "Foreign";
    UsagePlatform["AFM"] = "AFM";
    UsagePlatform["Traditional"] = "Traditional";
    UsagePlatform["Internet"] = "Internet";
    UsagePlatform["Network"] = "Network";
    UsagePlatform["WildSpot"] = "WildSpot";
    UsagePlatform["Dealer"] = "Dealer";
})(UsagePlatform || (exports.UsagePlatform = UsagePlatform = {}));
// Create a type for market specifications
var MarketSpecification;
(function (MarketSpecification) {
    MarketSpecification["All"] = "All Markets";
    MarketSpecification["NoNYChiLA"] = "All Markets (No NY/CHI/LA)";
    MarketSpecification["NoMajor"] = "No Major Markets";
    MarketSpecification["NYOnly"] = "NY Only";
    MarketSpecification["LAOrChicago"] = "LA Or Chicago Only";
    MarketSpecification["TwoOfLANYChicago"] = "2 Of LA, NY, Chicago";
    MarketSpecification["LANYAndChicago"] = "LA, NY, And Chicago";
    MarketSpecification["WithNY"] = "With NY";
    MarketSpecification["WithoutNY"] = "Without NY";
})(MarketSpecification || (exports.MarketSpecification = MarketSpecification = {}));
var UsageLanguage;
(function (UsageLanguage) {
    UsageLanguage["English"] = "English";
    UsageLanguage["Spanish"] = "Spanish";
    UsageLanguage["Japanese"] = "Japanese";
    UsageLanguage["Other"] = "Other";
})(UsageLanguage || (exports.UsageLanguage = UsageLanguage = {}));
var UsesType;
(function (UsesType) {
    UsesType["Unlimited"] = "Unlimited Use";
    UsesType["PerUse"] = "Per Use";
    UsesType["AcrossTheBoard"] = "Across The Board";
})(UsesType || (exports.UsesType = UsesType = {}));
var GlobalMarket;
(function (GlobalMarket) {
    GlobalMarket["Americas"] = "Americas";
    GlobalMarket["Caribbean"] = "Caribbean";
    GlobalMarket["AmericasAndCaribbean"] = "Americas And Caribbean";
    GlobalMarket["UK"] = "United Kingdom";
    GlobalMarket["Europe"] = "Europe";
    GlobalMarket["AsiaPacific"] = "Asia Pacific";
    GlobalMarket["Japan"] = "Japan";
    GlobalMarket["RestOfWorld"] = "Rest Of World";
    GlobalMarket["Worldwide"] = "Worldwide";
})(GlobalMarket || (exports.GlobalMarket = GlobalMarket = {}));
var CableMarket;
(function (CableMarket) {
    CableMarket["NationalCable"] = "National Cable";
    CableMarket["LocalCableUpTo1MSubscribers"] = "Local Cable (Up To 1M Subscribers)";
    CableMarket["LocalCable1MTo2MSubscribers"] = "Local Cable (1M To 2M Subscribers)";
    CableMarket["LocalCable2MPlusSubscribers"] = "Local Cable (2M Plus Subscribers)";
})(CableMarket || (exports.CableMarket = CableMarket = {}));
var AudioMadeMove;
(function (AudioMadeMove) {
    AudioMadeMove["MoveOver"] = "Move Over";
    AudioMadeMove["MadeFor"] = "Made For";
})(AudioMadeMove || (exports.AudioMadeMove = AudioMadeMove = {}));
var UsageTypeCategory;
(function (UsageTypeCategory) {
    UsageTypeCategory["NationalNetworks"] = "National Networks (Class A)";
    UsageTypeCategory["Cable"] = "Cable";
    UsageTypeCategory["NationalCable"] = "National Cable";
    UsageTypeCategory["SingleNetwork"] = "National Cable Single Network";
    UsageTypeCategory["LocalCable"] = "Local Cable";
    UsageTypeCategory["Wildspot"] = "Wildspot";
    UsageTypeCategory["Dealer"] = "Dealer";
    UsageTypeCategory["AllOtherNA"] = "All Other North American Use";
    UsageTypeCategory["SpanishLanguageProgramUse"] = "Spanish-Language Program Use";
    UsageTypeCategory["IONAndDiginet"] = "ION & Diginet";
    UsageTypeCategory["ForeignUse"] = "Foreign Use";
    UsageTypeCategory["TraditionalDigital"] = "Traditional Digital";
    UsageTypeCategory["TraditionalDigitalWithYouTube"] = "Traditional Digital w/YouTube";
    UsageTypeCategory["StreamingPlatforms"] = "Streaming Platforms";
    UsageTypeCategory["SocialMedia"] = "Social Media";
    UsageTypeCategory["YouTube"] = "YouTube";
    UsageTypeCategory["OtherPlatforms"] = "Gaming Platforms, VR/AR, Emerging Platforms";
    UsageTypeCategory["Print"] = "Print Use";
    UsageTypeCategory["OOH"] = "Out of Home Use";
    UsageTypeCategory["BTS"] = "B-roll & Behind the Scenes Use";
    UsageTypeCategory["TheatricalIndustrial"] = "Theatrical & Industrial Use";
    UsageTypeCategory["AFMSession"] = "AFM Session (1 hour)";
    UsageTypeCategory["AFMFirstUse"] = "AFM First Use";
    UsageTypeCategory["AFMForeign"] = "AFM Foreign Use";
    UsageTypeCategory["AFMInternetRadio"] = "AFM Internet Radio Spot";
    UsageTypeCategory["AFMReuse"] = "AFM Reuse";
    UsageTypeCategory["AFMNonBroadcast"] = "AFM Non-Broadcast Use";
    UsageTypeCategory["AFMInternet"] = "AFM Internet/New Media";
    UsageTypeCategory["AFMAllMedia"] = "AFM All Media";
    UsageTypeCategory["RadioNetwork"] = "Radio Network";
    UsageTypeCategory["RadioWildspot"] = "Radio Wildspot";
    UsageTypeCategory["InternetRadio"] = "Internet Radio";
    UsageTypeCategory["RadioDealer"] = "Radio Dealer";
})(UsageTypeCategory || (exports.UsageTypeCategory = UsageTypeCategory = {}));
// Very large enum - includes all usage types
// NOTE: The full UsageType enum is defined in apps/api/src/types/usage-types.ts
// and re-exported from there. We only include the enum declaration here for entity types.
var UsageType;
(function (UsageType) {
    UsageType["TV_LinearDomestic_Network_ClassA_Per_Use"] = "TV Linear Domestic Network Class A (Per Use)";
    UsageType["TV_LinearDomestic_Network_ClassA_13_Week_Maximum"] = "TV Linear Domestic Network Class A (13 Weeks Maximum)";
    UsageType["TV_LinearDomestic_IONAndDiginet_Per_Use"] = "TV Linear Domestic ION And Diginet Per Use";
    UsageType["TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use"] = "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_4_Week"] = "TV Spanish Language Program (4 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_13_Week"] = "TV Spanish Language Program (13 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_52_Week"] = "TV Spanish Language Program (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_4_Week"] = "TV Linear Domestic Wild Spot All Markets (4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_13_Week"] = "TV Linear Domestic Wild Spot All Markets (13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_52_Week"] = "TV Linear Domestic Wild Spot All Markets (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_4_Week"] = "TV Linear Domestic National Cable (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_13_Week"] = "TV Linear Domestic National Cable (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_52_Week"] = "TV Linear Domestic National Cable (52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_4_Week"] = "TV Linear Domestic National Cable Single Network (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_13_Week"] = "TV Linear Domestic National Cable Single Network (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_52_Week"] = "TV Linear Domestic National Cable Single Network (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_4_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_13_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_52_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_Dealer_4_Week"] = "TV Linear Domestic Dealer (4 Week)";
    UsageType["TV_LinearDomestic_Dealer_13_Week"] = "TV Linear Domestic Dealer (13 Week)";
    UsageType["TV_LinearDomestic_Dealer_52_Week"] = "TV Linear Domestic Dealer (52 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_4_Week"] = "TV Linear Domestic All Other NA Linear (4 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_13_Week"] = "TV Linear Domestic All Other NA Linear (13 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_52_Week"] = "TV Linear Domestic All Other NA Linear (52 Week)";
    UsageType["TV_TheatricalIndustrial_Up_To_30_Days"] = "TV Theatrical Industrial (Up To 30 Days)";
    UsageType["TV_TheatricalIndustrial_Use_Through_MPU"] = "TV Theatrical Industrial (Use Through MPU)";
    UsageType["TV_TheatricalIndustrial_Dist_On_Physical_Media"] = "TV Theatrical Industrial (Dist On Physical Media)";
    UsageType["TV_Digital_StreamingPlatforms_4_Week"] = "TV Digital Streaming Platforms (4 Week)";
    UsageType["TV_Digital_StreamingPlatforms_13_Week"] = "TV Digital Streaming Platforms (13 Week)";
    UsageType["TV_Digital_StreamingPlatforms_52_Week"] = "TV Digital Streaming Platforms (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_4_Week"] = "TV Digital Traditional Digital (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_13_Week"] = "TV Digital Traditional Digital (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_52_Week"] = "TV Digital Traditional Digital (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_4_Week"] = "TV Digital Traditional Digital w/YouTube (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_13_Week"] = "TV Digital Traditional Digital w/YouTube (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_52_Week"] = "TV Digital Traditional Digital w/YouTube (52 Week)";
    UsageType["TV_Digital_SocialMedia_30_Day_Cycle"] = "Social Media Waiver - Social Media (30 Day Cycle)";
    UsageType["TV_Digital_SocialMedia_YouTube"] = "Social Media Waiver - YouTube";
    UsageType["TV_Digital_GamingVRAREmergingPlatforms"] = "TV Digital Gaming VR/AR, Emerging Platforms";
    UsageType["TV_ForeignUse_UK"] = "TV Foreign Use - U.K.";
    UsageType["TV_ForeignUse_Europe"] = "TV Foreign Use - Europe";
    UsageType["TV_ForeignUse_AsiaPacific"] = "TV Foreign Use - Asia/Pacific";
    UsageType["TV_ForeignUse_Japan"] = "TV Foreign Use - Japan";
    UsageType["TV_ForeignUse_RestOfWorld"] = "TV Foreign Use - Rest-of-World";
    UsageType["TV_ForeignUse_Worldwide"] = "TV Foreign Use - Worldwide";
    UsageType["TV_ForeignUse_SpanishLanguage_Americas"] = "TV Foreign Use - Spanish Language (Americas)";
    UsageType["TV_ForeignUse_SpanishLanguage_Caribbean"] = "TV Foreign Use - Spanish Language (Caribbean)";
    UsageType["TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean"] = "TV Foreign Use - Spanish Language (Americas And Caribbean)";
    UsageType["TV_ForeignUse_Other_UK"] = "TV Foreign Use - Other (UK)";
    UsageType["TV_ForeignUse_Other_Japan"] = "TV Foreign Use - Other (Japan)";
    UsageType["TV_ForeignUse_Other_Europe"] = "TV Foreign Use - Other (Europe)";
    UsageType["TV_ForeignUse_Other_RestOfWorld"] = "TV Foreign Use - Other (Rest Of World)";
    UsageType["TV_ForeignUse_Other_AsiaPacific"] = "TV Foreign Use - Other (Asia Pacific)";
    UsageType["TV_ForeignUse_Other_Worldwide"] = "TV Foreign Use - Other (Worldwide)";
    UsageType["TV_AFM_FirstUse_InternetOnlyOrUS"] = "TV AFM First Use (Internet Only Or US)";
    UsageType["TV_AFM_Foreign_1_Year_Europe_NoEurope"] = "TV AFM Foreign - 1 Year (Europe/No Europe)";
    UsageType["TV_AFM_Foreign_Worldwide"] = "TV AFM Foreign (Worldwide)";
    UsageType["Radio_AFM_RadioSpot_Internet_8_Week"] = "Radio AFM Radio Spot - Internet (8 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_26_Week"] = "Radio AFM Radio Spot - Internet (26 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_52_Week"] = "Radio AFM Radio Spot - Internet (52 Week)";
    // AFM use for a TV or radio spot (the AFM wage summary), listed under both commercial types where it applies
    UsageType["AFM_Reuse_13_Week"] = "AFM Reuse, Dubbing, Conversion (13 Week)";
    UsageType["AFM_Reuse_Audio_8_Week"] = "AFM Audio/Radio Reuse (8 Week)";
    UsageType["AFM_NonBroadcast_8_Week"] = "AFM Non-Broadcast (8 Week)";
    UsageType["AFM_NonBroadcast_52_Week"] = "AFM Non-Broadcast (52 Week)";
    UsageType["AFM_NonBroadcast_104_Week"] = "AFM Non-Broadcast (104 Week)";
    UsageType["AFM_Foreign_2_Year_Europe_NoEurope"] = "AFM Foreign - 2 Years (Europe/No Europe)";
    UsageType["AFM_Foreign_2_Year_Worldwide"] = "AFM Foreign - 2 Years (Worldwide)";
    UsageType["AFM_Internet_8_Week"] = "AFM Internet/New Media (8 Week)";
    UsageType["AFM_Internet_26_Week"] = "AFM Internet/New Media (26 Week)";
    UsageType["AFM_Internet_52_Week"] = "AFM Internet/New Media (52 Week)";
    UsageType["AFM_AllMedia_Initial_52_Week"] = "AFM All Media Initial Use (52 Week)";
    UsageType["AFM_AllMedia_Reuse_52_Week"] = "AFM All Media Reuse (52 Week)";
    UsageType["Radio_Network_1_Week_Unlimited_Use"] = "Radio Network - 1 Week Unlimited Use";
    UsageType["Radio_Network_4_Weeks_Unlimited_Use"] = "Radio Network - 4 Week Unlimited Use";
    UsageType["Radio_Network_8_Weeks_Unlimited_Use"] = "Radio Network - 8 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_Unlimited_Use"] = "Radio Network - 13 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_26_Uses"] = "Radio Network - 13 Weeks 26 Uses";
    UsageType["Radio_Network_13_Week_39_Uses"] = "Radio Network - 13 Weeks 39 Uses";
    UsageType["Radio_Network_13_Week_Across_The_Board_Use"] = "Radio Network - 13 Weeks Across The Board Use";
    UsageType["Radio_WildSpot_8_Week_No_Major_Markets"] = "Radio Wild Spot - 8 Week (No Major Markets)";
    UsageType["Radio_WildSpot_8_Week_NY_Only"] = "Radio Wild Spot - 8 Week (NY Only)";
    UsageType["Radio_WildSpot_8_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 8 Week (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_8_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 8 Week (LA, NY, And Chicago)";
    UsageType["Radio_WildSpot_13_Week_No_Major_Markets"] = "Radio Wild Spot - 13 Weeks (No Major Markets)";
    UsageType["Radio_WildSpot_13_Week_NY_Only"] = "Radio Wild Spot - 13 Weeks (NY Only)";
    UsageType["Radio_WildSpot_13_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_13_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)";
    UsageType["Radio_Internet_4_Week"] = "Radio Internet - 4 Week";
    UsageType["Radio_Internet_8_Week_Move_Over"] = "Radio Internet - 8 Week Move Over";
    UsageType["Radio_Internet_8_Week_Made_For"] = "Radio Internet - 8 Week Made For";
    UsageType["Radio_Internet_1_Year_Move_Over"] = "Radio Internet - 1 Year Move Over";
    UsageType["Radio_Internet_1_Year_Made_For"] = "Radio Internet - 1 Year Made For";
    UsageType["Radio_Dealer_8_Week"] = "Radio Dealer - 8 Week";
    UsageType["Radio_Dealer_6_Months"] = "Radio Dealer - 6 Months";
})(UsageType || (exports.UsageType = UsageType = {}));
exports.commercialUsageTypes = {
    [commercial_types_1.CommercialType.TV]: [
        UsageType.TV_LinearDomestic_Network_ClassA_Per_Use,
        UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum,
        UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use,
        UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use,
        UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week,
        UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week,
        UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week,
        UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week,
        UsageType.TV_LinearDomestic_NationalCable_4_Week,
        UsageType.TV_LinearDomestic_NationalCable_13_Week,
        UsageType.TV_LinearDomestic_NationalCable_52_Week,
        UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week,
        UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week,
        UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week,
        UsageType.TV_LinearDomestic_LocalCable_4_Week,
        UsageType.TV_LinearDomestic_LocalCable_13_Week,
        UsageType.TV_LinearDomestic_LocalCable_52_Week,
        UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week,
        UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week,
        UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week,
        UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week,
        UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week,
        UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week,
        UsageType.TV_LinearDomestic_Dealer_4_Week,
        UsageType.TV_LinearDomestic_Dealer_13_Week,
        UsageType.TV_LinearDomestic_Dealer_52_Week,
        UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week,
        UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week,
        UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week,
        UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media,
        UsageType.TV_Digital_StreamingPlatforms_4_Week,
        UsageType.TV_Digital_StreamingPlatforms_13_Week,
        UsageType.TV_Digital_StreamingPlatforms_52_Week,
        UsageType.TV_Digital_TraditionalDigital_4_Week,
        UsageType.TV_Digital_TraditionalDigital_13_Week,
        UsageType.TV_Digital_TraditionalDigital_52_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        UsageType.TV_Digital_SocialMedia_YouTube,
        UsageType.TV_Digital_GamingVRAREmergingPlatforms,
        UsageType.TV_ForeignUse_UK,
        UsageType.TV_ForeignUse_Europe,
        UsageType.TV_ForeignUse_AsiaPacific,
        UsageType.TV_ForeignUse_Japan,
        UsageType.TV_ForeignUse_RestOfWorld,
        UsageType.TV_ForeignUse_Worldwide,
        UsageType.TV_ForeignUse_SpanishLanguage_Americas,
        UsageType.TV_ForeignUse_SpanishLanguage_Caribbean,
        UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean,
        UsageType.TV_ForeignUse_Other_UK,
        UsageType.TV_ForeignUse_Other_Japan,
        UsageType.TV_ForeignUse_Other_Europe,
        UsageType.TV_ForeignUse_Other_RestOfWorld,
        UsageType.TV_ForeignUse_Other_AsiaPacific,
        UsageType.TV_ForeignUse_Other_Worldwide,
        UsageType.TV_AFM_FirstUse_InternetOnlyOrUS,
        UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope,
        UsageType.TV_AFM_Foreign_Worldwide,
        UsageType.AFM_Foreign_2_Year_Europe_NoEurope,
        UsageType.AFM_Foreign_2_Year_Worldwide,
        UsageType.AFM_Reuse_13_Week,
        UsageType.AFM_NonBroadcast_8_Week,
        UsageType.AFM_NonBroadcast_52_Week,
        UsageType.AFM_NonBroadcast_104_Week,
        UsageType.AFM_Internet_8_Week,
        UsageType.AFM_Internet_26_Week,
        UsageType.AFM_Internet_52_Week,
        UsageType.AFM_AllMedia_Initial_52_Week,
        UsageType.AFM_AllMedia_Reuse_52_Week,
    ],
    [commercial_types_1.CommercialType.Digital]: [
        UsageType.TV_Digital_StreamingPlatforms_4_Week,
        UsageType.TV_Digital_StreamingPlatforms_13_Week,
        UsageType.TV_Digital_StreamingPlatforms_52_Week,
        UsageType.TV_Digital_TraditionalDigital_4_Week,
        UsageType.TV_Digital_TraditionalDigital_13_Week,
        UsageType.TV_Digital_TraditionalDigital_52_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        UsageType.TV_Digital_SocialMedia_30_Day_Cycle, // Social Media waiver
        UsageType.TV_Digital_SocialMedia_YouTube,
        UsageType.TV_Digital_GamingVRAREmergingPlatforms,
    ],
    [commercial_types_1.CommercialType.Social]: [
        UsageType.TV_Digital_SocialMedia_30_Day_Cycle, // Social Media waiver
        UsageType.TV_Digital_SocialMedia_YouTube,
    ],
    [commercial_types_1.CommercialType.OOH]: [
        UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media,
    ],
    [commercial_types_1.CommercialType.Radio]: [
        UsageType.Radio_AFM_RadioSpot_Internet_8_Week,
        UsageType.Radio_AFM_RadioSpot_Internet_26_Week,
        UsageType.Radio_AFM_RadioSpot_Internet_52_Week,
        UsageType.TV_AFM_FirstUse_InternetOnlyOrUS,
        UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope,
        UsageType.TV_AFM_Foreign_Worldwide,
        UsageType.AFM_Foreign_2_Year_Europe_NoEurope,
        UsageType.AFM_Foreign_2_Year_Worldwide,
        UsageType.AFM_Reuse_13_Week,
        UsageType.AFM_Reuse_Audio_8_Week,
        UsageType.AFM_NonBroadcast_8_Week,
        UsageType.AFM_NonBroadcast_52_Week,
        UsageType.AFM_NonBroadcast_104_Week,
        UsageType.AFM_AllMedia_Initial_52_Week,
        UsageType.AFM_AllMedia_Reuse_52_Week,
        UsageType.Radio_Network_1_Week_Unlimited_Use,
        UsageType.Radio_Network_4_Weeks_Unlimited_Use,
        UsageType.Radio_Network_8_Weeks_Unlimited_Use,
        UsageType.Radio_Network_13_Week_Unlimited_Use,
        UsageType.Radio_Network_13_Week_26_Uses,
        UsageType.Radio_Network_13_Week_39_Uses,
        UsageType.Radio_Network_13_Week_Across_The_Board_Use,
        UsageType.Radio_WildSpot_8_Week_No_Major_Markets,
        UsageType.Radio_WildSpot_8_Week_NY_Only,
        UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only,
        UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago,
        UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago,
        UsageType.Radio_WildSpot_13_Week_No_Major_Markets,
        UsageType.Radio_WildSpot_13_Week_NY_Only,
        UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only,
        UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago,
        UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago,
        UsageType.Radio_Internet_4_Week,
        UsageType.Radio_Internet_8_Week_Move_Over,
        UsageType.Radio_Internet_8_Week_Made_For,
        UsageType.Radio_Internet_1_Year_Move_Over,
        UsageType.Radio_Internet_1_Year_Made_For,
        UsageType.Radio_Dealer_8_Week,
        UsageType.Radio_Dealer_6_Months,
    ],
    [commercial_types_1.CommercialType.BTS]: [],
    [commercial_types_1.CommercialType.Other]: [],
    [commercial_types_1.CommercialType.Print]: [],
};
exports.usageTypeData = {
    /**
     * TV - Network Class A
     */
    [UsageType.TV_LinearDomestic_Network_ClassA_Per_Use]: {
        id: UsageType.TV_LinearDomestic_Network_ClassA_Per_Use,
        label: 'Domestic Network Class A',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalNetworks,
        usesType: UsesType.PerUse,
        perUse: true,
        specialAttributes: ['Domestic', 'Network', 'Class A'],
    },
    [UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum]: {
        id: UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum,
        label: 'Network Class A (13 Weeks Maximum)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalNetworks,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Network', 'Class A'],
    },
    /**
     * TV - ION & DigiNet
     */
    [UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use]: {
        id: UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use,
        label: 'ION And Diginet Per Use',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.IONAndDiginet,
        usesType: UsesType.PerUse,
        perUse: true,
        specialAttributes: ['Domestic', 'ION And Diginet'],
    },
    [UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use]: {
        id: UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use,
        label: 'ION And Diginet (13 Weeks Unlimited Use)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.IONAndDiginet,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'ION And Diginet'],
    },
    /**
     * TV - Spanish Language Program
     */
    [UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week]: {
        id: UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week,
        label: 'Spanish Language Program (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.SpanishLanguageProgramUse,
        language: UsageLanguage.Spanish,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Spanish Language Program'],
    },
    [UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week]: {
        id: UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week,
        label: 'Spanish Language Program (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.SpanishLanguageProgramUse,
        language: UsageLanguage.Spanish,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Spanish Language Program'],
    },
    [UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week]: {
        id: UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week,
        label: 'Spanish Language Program (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.SpanishLanguageProgramUse,
        language: UsageLanguage.Spanish,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Spanish Language Program'],
    },
    /**
     * TV - WildSpot
     */
    [UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week,
        label: 'Wild Spot All Markets (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.All,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets'],
    },
    [UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week,
        label: 'Wild Spot All Markets (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.All,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets'],
    },
    [UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week,
        label: 'Wild Spot All Markets (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.All,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets'],
    },
    [UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week,
        label: 'Wild Spot All Markets (No NY/LA - 4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.NoNYChiLA,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets', 'No NY/LA'],
    },
    [UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week,
        label: 'Wild Spot All Markets (No NY/LA - 13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.NoNYChiLA,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets', 'No NY/LA'],
    },
    [UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week]: {
        id: UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week,
        label: 'Wild Spot All Markets (No NY/LA - 52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Wildspot,
        marketSpec: MarketSpecification.NoNYChiLA,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Wild Spot', 'All Markets', 'No NY/LA'],
    },
    /**
     * TV - National Cable
     */
    [UsageType.TV_LinearDomestic_NationalCable_4_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_4_Week,
        label: 'National Cable (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable'],
    },
    [UsageType.TV_LinearDomestic_NationalCable_13_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_13_Week,
        label: 'National Cable (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable'],
    },
    [UsageType.TV_LinearDomestic_NationalCable_52_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_52_Week,
        label: 'National Cable (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable'],
    },
    /**
     * TV - National Cable Single Network
     */
    [UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week,
        label: 'National Cable - Single Network (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable', 'Single Network'],
    },
    [UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week,
        label: 'National Cable - Single Network (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable', 'Single Network'],
    },
    [UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week]: {
        id: UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week,
        label: 'National Cable - Single Network (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.NationalCable,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.NationalCable,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'National Cable', 'Single Network'],
    },
    /**
     * TV - Local Cable (Up to 1M Subs)
     */
    [UsageType.TV_LinearDomestic_LocalCable_4_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_4_Week,
        label: 'Local Cable (Up to 1M Subscribers) (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCableUpTo1MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', 'Up To 1M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_13_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_13_Week,
        label: 'Local Cable (Up to 1M Subscribers) (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCableUpTo1MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', 'Up To 1M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_52_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_52_Week,
        label: 'Local Cable (Up to 1M Subscribers) (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCableUpTo1MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', 'Up To 1M Subscribers'],
    },
    /**
     * TV - Local Cable (1M - 2M Subs)
     */
    [UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week,
        label: 'Local Cable (1M To 2M Subscribers) (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable1MTo2MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '1M To 2M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week,
        label: 'Local Cable (1M To 2M Subscribers) (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable1MTo2MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '1M To 2M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week,
        label: 'Local Cable (1M To 2M Subscribers) (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable1MTo2MSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '1M To 2M Subscribers'],
    },
    /**
     * TV - Local Cable (2M - 3M Subs)
     */
    [UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week,
        label: 'Local Cable (2M To 3M Subscribers) (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable2MPlusSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '2M To 3M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week,
        label: 'Local Cable (2M To 3M Subscribers) (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable2MPlusSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '2M To 3M Subscribers'],
    },
    [UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week]: {
        id: UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week,
        label: 'Local Cable (2M To 3M Subscribers) (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.LocalCable,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        cableMarket: CableMarket.LocalCable2MPlusSubscribers,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Local Cable', '2M To 3M Subscribers'],
    },
    /**
     * TV - Dealer
     */
    [UsageType.TV_LinearDomestic_Dealer_4_Week]: {
        id: UsageType.TV_LinearDomestic_Dealer_4_Week,
        label: 'Dealer (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Dealer,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Dealer'],
    },
    [UsageType.TV_LinearDomestic_Dealer_13_Week]: {
        id: UsageType.TV_LinearDomestic_Dealer_13_Week,
        label: 'Dealer (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Dealer,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Dealer'],
    },
    [UsageType.TV_LinearDomestic_Dealer_52_Week]: {
        id: UsageType.TV_LinearDomestic_Dealer_52_Week,
        label: 'Dealer (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.Dealer,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'Dealer'],
    },
    /**
     * TV - All Other NA Use
     */
    [UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week]: {
        id: UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week,
        label: 'All Other NA Linear (4 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.AllOtherNA,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'All Other NA Linear'],
    },
    [UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week]: {
        id: UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week,
        label: 'All Other NA Linear (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.AllOtherNA,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'All Other NA Linear'],
    },
    [UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week]: {
        id: UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week,
        label: 'All Other NA Linear (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Linear,
        category: UsageTypeCategory.AllOtherNA,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Domestic', 'All Other NA Linear'],
    },
    /**
     * TV - Foreign Use
     */
    [UsageType.TV_ForeignUse_UK]: {
        id: UsageType.TV_ForeignUse_UK,
        label: 'Foreign Use - U.K.',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        globalMarket: GlobalMarket.UK,
        specialAttributes: ['Foreign Use', 'UK'],
    },
    [UsageType.TV_ForeignUse_Japan]: {
        id: UsageType.TV_ForeignUse_Japan,
        label: 'Foreign Use - Japan',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        globalMarket: GlobalMarket.Japan,
        specialAttributes: ['Foreign Use', 'Japan'],
    },
    [UsageType.TV_ForeignUse_Europe]: {
        id: UsageType.TV_ForeignUse_Europe,
        label: 'Foreign Use - Europe',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        globalMarket: GlobalMarket.Europe,
        specialAttributes: ['Foreign Use', 'Europe'],
    },
    [UsageType.TV_ForeignUse_RestOfWorld]: {
        id: UsageType.TV_ForeignUse_RestOfWorld,
        label: 'Foreign Use - Rest-of-World',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        globalMarket: GlobalMarket.RestOfWorld,
        specialAttributes: ['Foreign Use', 'Rest Of World'],
    },
    [UsageType.TV_ForeignUse_AsiaPacific]: {
        id: UsageType.TV_ForeignUse_AsiaPacific,
        label: 'Foreign Use - Asia Pacific',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        usesType: UsesType.Unlimited,
        globalMarket: GlobalMarket.AsiaPacific,
        specialAttributes: ['Foreign Use', 'Asia Pacific'],
    },
    [UsageType.TV_ForeignUse_Worldwide]: {
        id: UsageType.TV_ForeignUse_Worldwide,
        label: 'Foreign Use - Worldwide',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        unlimitedUse: true,
        globalMarket: GlobalMarket.Worldwide,
        specialAttributes: ['Foreign Use', 'Worldwide'],
    },
    [UsageType.TV_ForeignUse_SpanishLanguage_Americas]: {
        id: UsageType.TV_ForeignUse_SpanishLanguage_Americas,
        label: 'Foreign Use - Spanish Language (Americas)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Spanish,
        globalMarket: GlobalMarket.Americas,
        specialAttributes: ['Foreign Use', 'Spanish Language'],
    },
    [UsageType.TV_ForeignUse_SpanishLanguage_Caribbean]: {
        id: UsageType.TV_ForeignUse_SpanishLanguage_Caribbean,
        label: 'Foreign Use - Spanish Language (Caribbean)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Spanish,
        globalMarket: GlobalMarket.Caribbean,
        specialAttributes: ['Foreign Use', 'Spanish Language'],
    },
    [UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean]: {
        id: UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean,
        label: 'Foreign Use - Spanish Language (Americas And Caribbean)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Spanish,
        globalMarket: GlobalMarket.AmericasAndCaribbean,
        specialAttributes: ['Foreign Use', 'Spanish Language'],
    },
    [UsageType.TV_ForeignUse_Other_UK]: {
        id: UsageType.TV_ForeignUse_Other_UK,
        label: 'Foreign Use - Other (UK)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.UK,
        specialAttributes: ['Foreign Use', 'Other', 'UK'],
    },
    [UsageType.TV_ForeignUse_Other_Japan]: {
        id: UsageType.TV_ForeignUse_Other_Japan,
        label: 'Foreign Use - Other (Japan)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.Japan,
        specialAttributes: ['Foreign Use', 'Other', 'Japan'],
    },
    [UsageType.TV_ForeignUse_Other_Europe]: {
        id: UsageType.TV_ForeignUse_Other_Europe,
        label: 'Foreign Use - Other (Europe)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.Europe,
        specialAttributes: ['Foreign Use', 'Other', 'Europe'],
    },
    [UsageType.TV_ForeignUse_Other_RestOfWorld]: {
        id: UsageType.TV_ForeignUse_Other_RestOfWorld,
        label: 'Foreign Use - Other (Rest Of World)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.RestOfWorld,
        specialAttributes: ['Foreign Use', 'Other', 'Rest Of World'],
    },
    [UsageType.TV_ForeignUse_Other_AsiaPacific]: {
        id: UsageType.TV_ForeignUse_Other_AsiaPacific,
        label: 'Foreign Use - Other (Asia Pacific)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.AsiaPacific,
        specialAttributes: ['Foreign Use', 'Other', 'Asia Pacific'],
    },
    [UsageType.TV_ForeignUse_Other_Worldwide]: {
        id: UsageType.TV_ForeignUse_Other_Worldwide,
        label: 'Foreign Use - Other (Worldwide)',
        media: MediaCategory.TV,
        platform: UsagePlatform.Foreign,
        category: UsageTypeCategory.ForeignUse,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        language: UsageLanguage.Other,
        globalMarket: GlobalMarket.Worldwide,
        specialAttributes: ['Foreign Use', 'Other', 'Worldwide'],
    },
    /**
     * TV - AFM
     */
    [UsageType.TV_AFM_FirstUse_InternetOnlyOrUS]: {
        id: UsageType.TV_AFM_FirstUse_InternetOnlyOrUS,
        label: 'AFM First Use (Internet Only Or US)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMFirstUse,
        usesType: UsesType.PerUse,
        perUse: true,
        useLimit: {
            minimum: 1,
            maximum: 1,
        },
        specialAttributes: ['AFM', 'First Use'],
    },
    [UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope]: {
        id: UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope,
        label: 'AFM Foreign - 1 Year (Europe/No Europe)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMForeign,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Foreign', '1 Year', 'Europe/No Europe'],
    },
    [UsageType.TV_AFM_Foreign_Worldwide]: {
        id: UsageType.TV_AFM_Foreign_Worldwide,
        label: 'AFM Foreign (Worldwide)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMForeign,
        globalMarket: GlobalMarket.Worldwide,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Foreign', 'Worldwide'],
    },
    /**
     * Digital - Streaming Platforms
     */
    [UsageType.TV_Digital_StreamingPlatforms_4_Week]: {
        id: UsageType.TV_Digital_StreamingPlatforms_4_Week,
        label: 'Digital Streaming Platforms (4 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.StreamingPlatforms,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Streaming Platforms'],
    },
    [UsageType.TV_Digital_StreamingPlatforms_13_Week]: {
        id: UsageType.TV_Digital_StreamingPlatforms_13_Week,
        label: 'Digital Streaming Platforms (13 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.StreamingPlatforms,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Streaming Platforms'],
    },
    [UsageType.TV_Digital_StreamingPlatforms_52_Week]: {
        id: UsageType.TV_Digital_StreamingPlatforms_52_Week,
        label: 'Digital Streaming Platforms (52 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.StreamingPlatforms,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Streaming Platforms'],
    },
    /**
     * Digital - Traditional Digital (no YouTube)
     */
    [UsageType.TV_Digital_TraditionalDigital_4_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_4_Week,
        label: 'Digital Traditional Digital (4 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigital,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital'],
    },
    [UsageType.TV_Digital_TraditionalDigital_13_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_13_Week,
        label: 'Digital Traditional Digital (13 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigital,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital'],
    },
    [UsageType.TV_Digital_TraditionalDigital_52_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_52_Week,
        label: 'Digital Traditional Digital (52 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigital,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital'],
    },
    /**
     * Digital - Traditional Digital w/YouTube
     */
    [UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        label: 'Digital Traditional Digital w/YouTube (4 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital', 'YouTube'],
    },
    [UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        label: 'Digital Traditional Digital w/YouTube (13 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital', 'YouTube'],
    },
    [UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week]: {
        id: UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        label: 'Digital Traditional Digital w/YouTube (52 Week)',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Digital', 'Traditional Digital', 'YouTube'],
    },
    [UsageType.TV_Digital_GamingVRAREmergingPlatforms]: {
        id: UsageType.TV_Digital_GamingVRAREmergingPlatforms,
        label: 'Digital Gaming VR/AR, Emerging Platforms',
        media: MediaCategory.Digital,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.OtherPlatforms,
        specialAttributes: ['Digital', 'Gaming VR/AR', 'Emerging Platforms'],
    },
    /**
     * Social Media Waiver
     */
    [UsageType.TV_Digital_SocialMedia_30_Day_Cycle]: {
        id: UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        label: 'Social Media (30 Day Cycle)',
        media: MediaCategory.Social,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.SocialMedia,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirty,
        cycle_unit: UsageCycleUnit.Day,
        specialAttributes: ['Digital', 'Social Media'],
    },
    [UsageType.TV_Digital_SocialMedia_YouTube]: {
        id: UsageType.TV_Digital_SocialMedia_YouTube,
        label: 'YouTube',
        media: MediaCategory.Social,
        platform: UsagePlatform.Digital,
        category: UsageTypeCategory.SocialMedia,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Digital', 'Social Media', 'YouTube'],
    },
    /**
     * Theatrical/Industrial
     */
    [UsageType.TV_TheatricalIndustrial_Up_To_30_Days]: {
        id: UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        label: 'Theatrical Industrial (Up To 30 Days)',
        media: MediaCategory.TV,
        platform: UsagePlatform.TheatricalIndustrial,
        category: UsageTypeCategory.TheatricalIndustrial,
        cycle_number: UsageCycleNumber.thirty,
        cycle_unit: UsageCycleUnit.Day,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Up To 30 Days'],
    },
    [UsageType.TV_TheatricalIndustrial_Use_Through_MPU]: {
        id: UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        label: 'Theatrical Industrial (Use Through MPU)',
        media: MediaCategory.TV,
        platform: UsagePlatform.TheatricalIndustrial,
        category: UsageTypeCategory.TheatricalIndustrial,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Use Through MPU'],
    },
    [UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media]: {
        id: UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media,
        label: 'Theatrical Industrial (Dist On Physical Media)',
        media: MediaCategory.TV,
        platform: UsagePlatform.TheatricalIndustrial,
        category: UsageTypeCategory.TheatricalIndustrial,
        specialAttributes: ['Dist On Physical Media'],
    },
    /**
     * Radio
     */
    [UsageType.Radio_AFM_RadioSpot_Internet_8_Week]: {
        id: UsageType.Radio_AFM_RadioSpot_Internet_8_Week,
        label: 'AFM Radio Spot - Internet (8 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternetRadio,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Radio Spot', 'Internet'],
    },
    [UsageType.Radio_AFM_RadioSpot_Internet_26_Week]: {
        id: UsageType.Radio_AFM_RadioSpot_Internet_26_Week,
        label: 'AFM Radio Spot - Internet (26 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternetRadio,
        cycle_number: UsageCycleNumber.twentySix,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Radio Spot', 'Internet'],
    },
    [UsageType.Radio_AFM_RadioSpot_Internet_52_Week]: {
        id: UsageType.Radio_AFM_RadioSpot_Internet_52_Week,
        label: 'AFM Radio Spot - Internet (52 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternetRadio,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Radio Spot', 'Internet'],
    },
    /**
     * AFM use for a TV or radio spot (per spot). The media is TV's, but these are listed under radio
     * commercials too where the AFM wage summary applies them to radio.
     */
    [UsageType.AFM_Reuse_13_Week]: {
        id: UsageType.AFM_Reuse_13_Week,
        label: 'AFM Reuse, Dubbing, Conversion (13 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMReuse,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Reuse', '13 Week'],
    },
    [UsageType.AFM_Reuse_Audio_8_Week]: {
        id: UsageType.AFM_Reuse_Audio_8_Week,
        label: 'AFM Audio/Radio Reuse (8 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMReuse,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Reuse', 'Audio', '8 Week'],
    },
    [UsageType.AFM_NonBroadcast_8_Week]: {
        id: UsageType.AFM_NonBroadcast_8_Week,
        label: 'AFM Non-Broadcast (8 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMNonBroadcast,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Non-Broadcast', '8 Week'],
    },
    [UsageType.AFM_NonBroadcast_52_Week]: {
        id: UsageType.AFM_NonBroadcast_52_Week,
        label: 'AFM Non-Broadcast (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMNonBroadcast,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Non-Broadcast', '52 Week'],
    },
    [UsageType.AFM_NonBroadcast_104_Week]: {
        id: UsageType.AFM_NonBroadcast_104_Week,
        label: 'AFM Non-Broadcast (104 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMNonBroadcast,
        cycle_number: UsageCycleNumber.oneHundredFour,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Non-Broadcast', '104 Week'],
    },
    [UsageType.AFM_Foreign_2_Year_Europe_NoEurope]: {
        id: UsageType.AFM_Foreign_2_Year_Europe_NoEurope,
        label: 'AFM Foreign - 2 Years (Europe/No Europe)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMForeign,
        cycle_number: UsageCycleNumber.oneHundredFour,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Foreign', '2 Years', 'Europe/No Europe'],
    },
    [UsageType.AFM_Foreign_2_Year_Worldwide]: {
        id: UsageType.AFM_Foreign_2_Year_Worldwide,
        label: 'AFM Foreign - 2 Years (Worldwide)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMForeign,
        cycle_number: UsageCycleNumber.oneHundredFour,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Foreign', '2 Years', 'Worldwide'],
    },
    [UsageType.AFM_Internet_8_Week]: {
        id: UsageType.AFM_Internet_8_Week,
        label: 'AFM Internet/New Media (8 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternet,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Internet', '8 Week'],
    },
    [UsageType.AFM_Internet_26_Week]: {
        id: UsageType.AFM_Internet_26_Week,
        label: 'AFM Internet/New Media (26 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternet,
        cycle_number: UsageCycleNumber.twentySix,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Internet', '26 Week'],
    },
    [UsageType.AFM_Internet_52_Week]: {
        id: UsageType.AFM_Internet_52_Week,
        label: 'AFM Internet/New Media (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMInternet,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'Internet', '52 Week'],
    },
    [UsageType.AFM_AllMedia_Initial_52_Week]: {
        id: UsageType.AFM_AllMedia_Initial_52_Week,
        label: 'AFM All Media Initial Use (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMAllMedia,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'All Media', 'Initial Use', '52 Week'],
    },
    [UsageType.AFM_AllMedia_Reuse_52_Week]: {
        id: UsageType.AFM_AllMedia_Reuse_52_Week,
        label: 'AFM All Media Reuse (52 Week)',
        media: MediaCategory.TV,
        platform: UsagePlatform.AFM,
        category: UsageTypeCategory.AFMAllMedia,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['AFM', 'All Media', 'Reuse', '52 Week'],
    },
    [UsageType.Radio_Network_1_Week_Unlimited_Use]: {
        id: UsageType.Radio_Network_1_Week_Unlimited_Use,
        label: 'Radio Network (1 Week Unlimited Use)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.one,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Radio', 'Network', '1 Week', 'Unlimited Use'],
    },
    [UsageType.Radio_Network_4_Weeks_Unlimited_Use]: {
        id: UsageType.Radio_Network_4_Weeks_Unlimited_Use,
        label: 'Radio Network (4 Weeks Unlimited Use)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Radio', 'Network', '4 Weeks', 'Unlimited Use'],
    },
    [UsageType.Radio_Network_8_Weeks_Unlimited_Use]: {
        id: UsageType.Radio_Network_8_Weeks_Unlimited_Use,
        label: 'Radio Network (8 Weeks Unlimited Use)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Radio', 'Network', '8 Weeks', 'Unlimited Use'],
    },
    [UsageType.Radio_Network_13_Week_Unlimited_Use]: {
        id: UsageType.Radio_Network_13_Week_Unlimited_Use,
        label: 'Radio Network (13 Weeks Unlimited Use)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: ['Radio', 'Network', '13 Weeks', 'Unlimited Use'],
    },
    [UsageType.Radio_Network_13_Week_26_Uses]: {
        id: UsageType.Radio_Network_13_Week_26_Uses,
        label: 'Radio Network (13 Weeks, 26 Uses)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.PerUse,
        perUse: true,
        useLimit: {
            maximum: 26,
        },
        specialAttributes: ['Radio', 'Network', '13 Weeks', '26 Uses'],
    },
    [UsageType.Radio_Network_13_Week_39_Uses]: {
        id: UsageType.Radio_Network_13_Week_39_Uses,
        label: 'Radio Network (13 Weeks, 39 Uses)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        usesType: UsesType.PerUse,
        perUse: true,
        useLimit: {
            maximum: 39,
        },
        specialAttributes: ['Radio', 'Network', '13 Weeks', '39 Uses'],
    },
    [UsageType.Radio_Network_13_Week_Across_The_Board_Use]: {
        id: UsageType.Radio_Network_13_Week_Across_The_Board_Use,
        label: 'Radio Network (13 Weeks, Across The Board Use)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Network,
        category: UsageTypeCategory.RadioNetwork,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Network', '13 Weeks', 'Across The Board Use'],
    },
    /**
     * Radio - WildSpot
     */
    [UsageType.Radio_WildSpot_8_Week_No_Major_Markets]: {
        id: UsageType.Radio_WildSpot_8_Week_No_Major_Markets,
        label: 'Radio Wild Spot (8 Week, No Major Markets)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '8 Week', 'No Major Markets'],
        marketSpec: MarketSpecification.NoMajor,
    },
    [UsageType.Radio_WildSpot_8_Week_NY_Only]: {
        id: UsageType.Radio_WildSpot_8_Week_NY_Only,
        label: 'Radio Wild Spot (8 Week, NY Only)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '8 Week', 'NY Only'],
        marketSpec: MarketSpecification.NYOnly,
    },
    [UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only]: {
        id: UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only,
        label: 'Radio Wild Spot (8 Week, LA Or Chicago Only)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '8 Week', 'LA Or Chicago Only'],
        marketSpec: MarketSpecification.LAOrChicago,
    },
    [UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago]: {
        id: UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago,
        label: 'Radio Wild Spot (8 Week, 2 Of LA, NY, Chicago)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '8 Week', '2 Of LA, NY, Chicago'],
        marketSpec: MarketSpecification.TwoOfLANYChicago,
    },
    [UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago]: {
        id: UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago,
        label: 'Radio Wild Spot (8 Week, LA, NY, And Chicago)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '8 Week', 'LA, NY, And Chicago'],
        marketSpec: MarketSpecification.LANYAndChicago,
    },
    [UsageType.Radio_WildSpot_13_Week_No_Major_Markets]: {
        id: UsageType.Radio_WildSpot_13_Week_No_Major_Markets,
        label: 'Radio Wild Spot (13 Weeks, No Major Markets)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '13 Weeks', 'No Major Markets'],
        marketSpec: MarketSpecification.NoMajor,
    },
    [UsageType.Radio_WildSpot_13_Week_NY_Only]: {
        id: UsageType.Radio_WildSpot_13_Week_NY_Only,
        label: 'Radio Wild Spot (13 Weeks, NY Only)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '13 Weeks', 'NY Only'],
        marketSpec: MarketSpecification.NYOnly,
    },
    [UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only]: {
        id: UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only,
        label: 'Radio Wild Spot (13 Weeks, LA Or Chicago Only)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Wild Spot', '13 Weeks', 'LA Or Chicago Only'],
        marketSpec: MarketSpecification.LAOrChicago,
    },
    [UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago]: {
        id: UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago,
        label: 'Radio Wild Spot (13 Weeks, 2 Of LA, NY, Chicago)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            '2 Of LA, NY, Chicago',
        ],
        marketSpec: MarketSpecification.TwoOfLANYChicago,
    },
    [UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago]: {
        id: UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago,
        label: 'Radio Wild Spot (13 Weeks, LA, NY, And Chicago)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.WildSpot,
        category: UsageTypeCategory.RadioWildspot,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.thirteen,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'LA, NY, And Chicago',
        ],
        marketSpec: MarketSpecification.LANYAndChicago,
    },
    /**
     * Radio - Internet
     */
    [UsageType.Radio_Internet_4_Week]: {
        id: UsageType.Radio_Internet_4_Week,
        label: 'Radio Internet (4 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Internet,
        category: UsageTypeCategory.InternetRadio,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.four,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Internet', '4 Week'],
    },
    [UsageType.Radio_Internet_8_Week_Move_Over]: {
        id: UsageType.Radio_Internet_8_Week_Move_Over,
        label: 'Radio Internet (8 Week Move Over)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Internet,
        category: UsageTypeCategory.InternetRadio,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Internet', '8 Week Move Over'],
    },
    [UsageType.Radio_Internet_8_Week_Made_For]: {
        id: UsageType.Radio_Internet_8_Week_Made_For,
        label: 'Radio Internet (8 Week Made For)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Internet,
        category: UsageTypeCategory.InternetRadio,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Internet', '8 Week Made For'],
        audioMadeMove: AudioMadeMove.MadeFor,
    },
    [UsageType.Radio_Internet_1_Year_Move_Over]: {
        id: UsageType.Radio_Internet_1_Year_Move_Over,
        label: 'Radio Internet (1 Year Move Over)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Internet,
        category: UsageTypeCategory.InternetRadio,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Internet', '1 Year Move Over'],
        audioMadeMove: AudioMadeMove.MoveOver,
    },
    [UsageType.Radio_Internet_1_Year_Made_For]: {
        id: UsageType.Radio_Internet_1_Year_Made_For,
        label: 'Radio Internet (1 Year Made For)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Internet,
        category: UsageTypeCategory.InternetRadio,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.fiftyTwo,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Internet', '1 Year Made For'],
        audioMadeMove: AudioMadeMove.MadeFor,
    },
    /**
     * Radio - Dealer
     */
    [UsageType.Radio_Dealer_8_Week]: {
        id: UsageType.Radio_Dealer_8_Week,
        label: 'Radio Dealer (8 Week)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Dealer,
        category: UsageTypeCategory.RadioDealer,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.eight,
        cycle_unit: UsageCycleUnit.Week,
        specialAttributes: ['Radio', 'Dealer', '8 Week'],
    },
    [UsageType.Radio_Dealer_6_Months]: {
        id: UsageType.Radio_Dealer_6_Months,
        label: 'Radio Dealer (6 Months)',
        media: MediaCategory.Radio,
        platform: UsagePlatform.Dealer,
        category: UsageTypeCategory.RadioDealer,
        usesType: UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: UsageCycleNumber.six,
        cycle_unit: UsageCycleUnit.Month,
        specialAttributes: ['Radio', 'Dealer', '6 Months'],
    },
};
//# sourceMappingURL=usage-types.js.map